import { createGeofenceSubscriptionData } from './createGeofenceSubscriptionData';
import { GEOFENCES_ALL_GEOFENCES } from 'containers/Ezlo/EzloMeshbot/constants';
import { isUserGeofenceDevice } from 'containers/Ezlo/EzloMeshbot/utils/isUserGeofenceDevice';

/**
 * Adds geofence subscription data to the subscriptions store if it's missing for a given user.
 *
 * Checks whether the corresponding abstract device and geofence item exist on the provided hub.
 * If either is missing, it pushes the user's UUID into `abstractsUuids` (if not already present),
 * and adds geofence subscription data to `hubSubscriptions`.
 *
 * @param {Object} subscriptionsStore - The store that tracks required subscriptions.
 * @param {string[]} subscriptionsStore.abstractsUuids - List of abstract UUIDs needing device info.
 * @param {Array<Object>} subscriptionsStore.hubSubscriptions - List of hub subscriptions to register.
 * @param {Object} item - Trigger block containing `blockMeta` with the user UUID.
 * @param {Object} ezlo - The ezlo hub object containing devices and items.
 *
 * @example
 * setGeofenceDataForSubscriptions(subscriptionsStore, item, ezlo);
 */
export const setGeofenceDataForSubscriptions = (subscriptionsStore, item, ezlo) => {
    const hubData = ezlo?.data?.[ezlo?.serial];
    const devices = hubData?.devices || [];
    const items = hubData?.items || [];

    const { user } = item.blockMeta;
    const userAbstractDevice = devices.find((device) => isUserGeofenceDevice(device, user));
    const geofencesItem = items.find(
        (item) => item.deviceId === userAbstractDevice?._id && item.name === GEOFENCES_ALL_GEOFENCES,
    );

    if (!userAbstractDevice || !geofencesItem) {
        if (!subscriptionsStore.abstractsUuids.includes(user)) {
            subscriptionsStore.abstractsUuids.push(user);
        }

        subscriptionsStore.hubSubscriptions.push(createGeofenceSubscriptionData(item.blockMeta));
    }
};
